import { render } from "./A6Form.vue?vue&type=template&id=4b4fed4f&scoped=true"
import script from "./A6Form.vue?vue&type=script&lang=js"
export * from "./A6Form.vue?vue&type=script&lang=js"

import "./A6Form.vue?vue&type=style&index=0&id=4b4fed4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4fed4f"]])

export default __exports__